import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import bag from "../../Assets/Images/profile/defaultProfile.jpg";
import { ToastContainer, toast } from 'react-toastify';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import CompLoaderBtn from '../Common/CompLoaderBtn';
import CompLoaderDt from '../Common/CompLoaderDt';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';

function CompDtMoneyTransferBaseOrder({ items }) {
    const { t } = useTranslation();
    const [componentId] = useState('compDtMoneyTransferBaseOrder');
    const [data, setData] = useState(null);

    const navigate = useNavigate();

    const [apiCalled, setApiCalled] = useState(false);

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const callOrderDetails = (orderData) => {
        setApiCalled(true);
        let requestBody = {

        };
        const timeout = setTimeout(() => {
            let message = t('product.common-notification.will-be-develop');
            toast.warning(message, { autoClose: 1000 });
            setApiCalled(false);
            let redirectUrl = '/market-place-management/orders/' + orderData?.code;
            //window.location.href = redirectUrl;
            //navigate(redirectUrl);
        }, 100);
    };

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            console.log(items);
            setData(items);
        }
    }, [items]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.seller')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.sellerCrm?.title}>{row?.sellerCrm?.title}</span>
                            <span> </span>
                            <span>{row?.sellerCrm?.contactIdentityValidation === true ?
                                <span className='text-success'><CheckCircleOutlined /></span>
                                :
                                <span className='text-danger'><CloseCircleOutlined /></span>
                            }
                            </span></h6>
                        <p className="text-muted mb-2"><span title={row?.sellerCrm?.segment?.label}>{row?.sellerCrm?.segment?.label}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "255px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.category-and-product')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.product?.name}>{row?.product?.name}</span></h6>
                        <p className="text-muted mb-2"><span title={row?.status?.label}>{t('language') === 'tr' ? <span title={row?.category?.labelTr}>{row?.category?.labelTr}</span> : <span title={row?.category?.labelEn}>{row?.category?.labelEn}</span>}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "285px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.unit-collection-amount')}</span>,
            selector: row => <><span>{'₺ '}</span><CurrencyFormat value={row?.unitPrice} displayType={'text'} thousandSeparator={true} />
                <span> x </span><span title={row?.amount}>{row?.amount}</span>
                <span> </span>
                <span title={row?.product?.unitType?.label}>{row?.product?.unitType?.label}</span></>,
            sortable: false,
            maxWidth: "165px"
        },

        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.unit-transfer-amount')}</span>,
            selector: row => <><span>{'₺ '}</span><CurrencyFormat value={row?.mpNetAmount} displayType={'text'} thousandSeparator={true} />
                <span> x </span><span title={row?.amount}>{row?.amount}</span>
                <span> </span>
                <span title={row?.product?.unitType?.label}>{row?.product?.unitType?.label}</span></>,
            sortable: false,
            maxWidth: "165px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.commission-rate')}</span>,
            selector: row => <span title={'% ' + row?.mpCommissionRate}>% {row?.mpCommissionRate}</span>,
            sortable: false,
            maxWidth: "110px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.total-collection-amount')}</span>,
            selector: row => <><span>{'₺ '}</span><CurrencyFormat value={row?.total} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer.comp-dt-money-transfer-base-order.dt.th.total-transfer-amount')}</span>,
            selector: row => <><span>{'₺ '}</span><CurrencyFormat value={row?.mpNetAmount * row?.amount} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            /*
            name: <span className='font-weight-bold fs-13'>{t('components.market-place-management-orders.comp-dt-orders.dt.th.actions')}</span>,
            selector: row =>
                <>
                    <Button onClick={e => callOrderDetails(row)} className={apiCalled === true ? 'btn btn-dark border-0 border w-100 disabled' : 'btn btn-dark border-0 border w-100'}>
                        <div className={apiCalled === true ? '' : 'd-none'}>
                            <CompLoaderBtn />
                        </div>
                        <span className={apiCalled !== true ? '' : 'd-none'}>{t('components.market-place-management-orders.comp-dt-orders.dt.td.button.details')}</span>
                    </Button>
                </>

            ,
            sortable: false,
            maxWidth: "275px"
            */
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data);
            setPending(false);
            setTotalRows(data?.length);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={false}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtMoneyTransferBaseOrder;